export function parseLocalDate(yyyyMmDd) {
  if (!yyyyMmDd) return null;
  const [y, m, d] = yyyyMmDd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function toYyyyMmDd(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function isWeekend(date) {
  const dow = date.getDay();
  return dow === 0 || dow === 6; // Sun=0, Sat=6
}

export function holidaysSet(holidays) {
  // holidays: array of { date | Date | string, isActive }
  const set = new Set();
  (holidays || []).forEach(h => {
    const active = (h.isActive ?? h.IsActive ?? true);
    if (!active) return;
    const raw = h.date || h.Date || h;
    const d = raw instanceof Date ? raw : parseLocalDate(String(raw).substring(0,10));
    if (d) set.add(toYyyyMmDd(d));
  });
  return set;
}

export function isBusinessDay(date, holidaySet) {
  if (isWeekend(date)) return false;
  return !holidaySet.has(toYyyyMmDd(date));
}

export function addBusinessDays(startYmd, businessDays, holidays) {
  if (!startYmd || businessDays <= 0) return startYmd;
  const start = parseLocalDate(startYmd);
  const hset = holidaysSet(holidays);
  let d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let count = 0;
  while (true) {
    if (isBusinessDay(d, hset)) {
      count++;
      if (count >= businessDays) break;
    }
    d.setDate(d.getDate() + 1);
  }
  return toYyyyMmDd(d);
}

export function countBusinessDays(startYmd, endYmd, holidays) {
  if (!startYmd || !endYmd) return 0;
  const start = parseLocalDate(startYmd);
  const end = parseLocalDate(endYmd);
  if (end < start) return 0;
  const hset = holidaysSet(holidays);
  let count = 0;
  const d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  while (d <= end) {
    if (isBusinessDay(d, hset)) count++;
    d.setDate(d.getDate() + 1);
  }
  return count;
}

